import { render, staticRenderFns } from "./AlterarSenha.vue?vue&type=template&id=61bf7444&scoped=true&"
import script from "./AlterarSenha.vue?vue&type=script&lang=js&"
export * from "./AlterarSenha.vue?vue&type=script&lang=js&"
import style0 from "./AlterarSenha.vue?vue&type=style&index=0&id=61bf7444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bf7444",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61bf7444')) {
      api.createRecord('61bf7444', component.options)
    } else {
      api.reload('61bf7444', component.options)
    }
    module.hot.accept("./AlterarSenha.vue?vue&type=template&id=61bf7444&scoped=true&", function () {
      api.rerender('61bf7444', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Perfil/internalPages/AlterarSenha.vue"
export default component.exports